<base-infinite-scroll (scrollDownEvent)="onScrollDown()">
  <base-customer-inquiry-offer
    *ngFor="let offer of offers; trackBy: trackByOffer"
    [ngClass]="{
      'inquiry-teaser-selected': offer.data.isSelected,
      'offer-sent': offer.data.status === offerStatuses.open,
      'offer-declined': offer.data.status === offerStatuses.declined,
      'offer-confirmed': offer.data.status === offerStatuses.confirmed,
      'offer-needs-confirmation': offer.data.status === offerStatuses.needsConfirmation,
      'offer-preselected':
        isOfferPreselectionAllowed &&
        offer.data.status === offerStatuses.open &&
        offer.data.preselected &&
        !offer.data.workCouncilStatus,
      'offer-work-council-approved':
        offer.data.workCouncilStatus === offerWorkCouncilStatuses.APPROVED ||
        offer.data.workCouncilStatus === offerWorkCouncilStatuses.AUTO_APPROVED ||
        offer.data.workCouncilStatus === offerWorkCouncilStatuses.NOTED,
      'offer-work-council-disapproved': offer.data.workCouncilStatus === offerWorkCouncilStatuses.DISAPPROVED
    }"
    class="inquiry-teaser inquiry-employee-container p-0"
    [offer]="offer"
    [modalRef]="modalRef"
    [canAcceptOffers]="canAcceptOffers"
    [isOfferPreselectionAllowed]="isOfferPreselectionAllowed"
    [assignmentInfo]="assignmentInfo"
    [hasAdminAssignmentsPermission]="hasAdminAssignmentsPermission"
    [inquiry]="inquiry"
    [shiftTimesWithFlex]="shiftTimesWithFlex"
  ></base-customer-inquiry-offer>
</base-infinite-scroll>

<base-empty-list-row
  *ngIf="!offers.length"
  message="dashboardInfo.noOffers"
></base-empty-list-row>
